import { render, staticRenderFns } from "./LogVirtualAccountForm.vue?vue&type=template&id=4f0f117d&lang=pug"
import script from "./LogVirtualAccountForm.vue?vue&type=script&lang=js"
export * from "./LogVirtualAccountForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports